import React, { useEffect } from 'react';
import useRouteStatus from '../../../hooks/useRouteStatus';

import { useDispatch } from 'react-redux';
import { submitSoftApplication } from '../../../actions/applications';
import useSessionEntity from '../../../hooks/useSessionEntity';

import checkmark from '../../../images/green_checkmark.svg';
import approved from '../../../images/approved_text.svg';
import ReturnToMerchant from '../../shared/ReturnToMerchant';

export default function Vip({ location }) {
  const dispatch = useDispatch();
  const application = useSessionEntity('application');
  const merchant = useSessionEntity('merchant');
  useRouteStatus(location);

  useEffect(() => {
    if (!application.submitted) {
      dispatch(submitSoftApplication(application));
    }
  }, []);

  return (
    <div id="content" className="has-text-centered">
      <div className="is-size-4 has-text-weight-semibold">
        Success!
      </div>
      <p className="mt-1  mb-3" style={{ color: "#7A899A" }}>
        Our VIP team is working on getting you the best rate, and will be in touch shortly.
      </p>
      <div className="mt-3">
        <img
          alt="Green Checkmark"
          src={checkmark}
        />
      </div>
      <ReturnToMerchant merchant={merchant} />
    </div>
  );
}
